(function() {
  if (window.__storeLocationsTabsInitialized) {
    return;
  }

  window.__storeLocationsTabsInitialized = true;

  var SECTION_SELECTOR = "[data-store-locations-tabs]";

  function setActiveTab(sectionElement, tabs, panels, nextIndex, shouldFocus) {
    if (nextIndex < 0 || nextIndex >= tabs.length) {
      return;
    }

    for (var i = 0; i < tabs.length; i += 1) {
      var tab = tabs[i];
      var isActive = i === nextIndex;

      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");

      if (isActive && shouldFocus) {
        tab.focus();
      }
    }

    for (var panelIndex = 0; panelIndex < panels.length; panelIndex += 1) {
      var panel = panels[panelIndex];
      var panelIsActive = panelIndex === nextIndex;

      panel.classList.toggle("is-active", panelIsActive);

      if (panelIsActive) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    }

    sectionElement.setAttribute("data-store-locations-active-index", String(nextIndex));
  }

  function initializeSection(sectionElement) {
    if (!sectionElement || sectionElement.getAttribute("data-store-locations-ready") === "true") {
      return;
    }

    var tabs = Array.prototype.slice.call(sectionElement.querySelectorAll("[data-store-locations-tab]"));
    var panels = Array.prototype.slice.call(sectionElement.querySelectorAll("[data-store-locations-panel]"));

    if (tabs.length === 0 || tabs.length !== panels.length) {
      return;
    }

    sectionElement.setAttribute("data-store-locations-ready", "true");

    var initialIndex = 0;

    for (var i = 0; i < tabs.length; i += 1) {
      if (tabs[i].getAttribute("aria-selected") === "true") {
        initialIndex = i;
        break;
      }
    }

    setActiveTab(sectionElement, tabs, panels, initialIndex, false);

    var onTabClick = function(event) {
      var clickedTab = event.currentTarget;
      var index = tabs.indexOf(clickedTab);

      if (index < 0) {
        return;
      }

      setActiveTab(sectionElement, tabs, panels, index, false);
    };

    var onTabKeydown = function(event) {
      var key = event.key;

      if (
        key !== "ArrowRight" &&
        key !== "ArrowLeft" &&
        key !== "ArrowDown" &&
        key !== "ArrowUp" &&
        key !== "Home" &&
        key !== "End"
      ) {
        return;
      }

      event.preventDefault();

      var currentTab = event.currentTarget;
      var currentIndex = tabs.indexOf(currentTab);
      var nextIndex = currentIndex;

      if (key === "Home") {
        nextIndex = 0;
      } else if (key === "End") {
        nextIndex = tabs.length - 1;
      } else if (key === "ArrowRight" || key === "ArrowDown") {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (key === "ArrowLeft" || key === "ArrowUp") {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      }

      setActiveTab(sectionElement, tabs, panels, nextIndex, true);
    };

    for (var tabIndex = 0; tabIndex < tabs.length; tabIndex += 1) {
      tabs[tabIndex].addEventListener("click", onTabClick);
      tabs[tabIndex].addEventListener("keydown", onTabKeydown);
    }
  }

  function initializeAll(rootElement) {
    var scope = rootElement && rootElement.querySelectorAll ? rootElement : document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);

    for (var i = 0; i < sections.length; i += 1) {
      initializeSection(sections[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initializeAll(document);
    }, { once: true });
  } else {
    initializeAll(document);
  }

  document.addEventListener("shopify:section:load", function(event) {
    initializeAll(event.target || document);
  });
})();
